/**
 * vue 全局方法、全局混入定义
 *
 */
import { showTips, confirmWarning } from './lib//message';
import { formatDate, parseDate } from './lib/dateUtils';
import { regExps } from './lib/validateUtils';

import myTable from './components/table/my-table.vue'
import XttDialog from './components/xttcpt/XttDialog.vue';
import ImgUpload from './components/xttcpt/ImgUpload.vue';
import ImgPreview from './components/xttcpt/ImgPreview.vue';
// import Scrollbar from './components/xttcpt/Scrollbar.vue';
import CheckboxTooltip from './components/xttcpt/checkbox/CheckboxTooltip.vue';
import CheckboxAll from './components/xttcpt/checkbox/CheckboxAll.vue';
import RadioTooltip from './components/xttcpt/RadioTooltip.vue';
import SelectFilter from './components/xttcpt/select/SelectFilter.vue';

/**
 * 绑定全局方法到vue
 *
 * $showTips 显示消息提示框
 * $confirmWarning warning级别confirm弹框
 *
 * $formatDate 将日期格式化为字符串
 * $parseDate 将字符串转化为日期
 *
 * --------- components -----------
 * XttDialog 弹框
 * CheckboxTooltip 带提示的checkbox
 * CheckboxAll 带全选的checkbox
 * RadioTooltip 带提示的radio
 * DictSelect 字典表下拉
 * SelectFilter 支持自定义搜索key的select
 * InitialsInput 带智能提示的拼音简称输入框
 *
 * ImgUpload 图片上传组件
 * ImgPreview 图片预览组件
 *
 *
 * .param {*} Vue
 * .param {*} options
 */
export default function install(Vue, options) {
    // ------------------------------------- 添加全局方法或属性  -------------------------------------
    // 常用提示
    Vue.prototype.$showTips = showTips;
    Vue.prototype.$confirmWarning = confirmWarning;
    // 日期
    Vue.prototype.$formatDate = formatDate;
    Vue.prototype.$parseDate = parseDate;
    // 通用正则表达式
    Vue.prototype.$regExps = regExps;
    // ------------------------------------- 组件注入 -------------------------------------
    /* 全局弹框 */
    Vue.component('XttDialog', XttDialog);
    /** 带提示的checkbox */
    Vue.component('CheckboxTooltip', CheckboxTooltip);
    /** 带全选的checkbox */
    Vue.component('CheckboxAll', CheckboxAll);
    /** 带提示的radio */
    Vue.component('RadioTooltip', RadioTooltip);
    /* 自定义搜索下拉 */
    Vue.component('SelectFilter', SelectFilter);
    /** 图片上传 */
    Vue.component('ImgUpload', ImgUpload);
    /** 图片预览 */
    Vue.component('ImgPreview', ImgPreview);
    /** 滚动条 */
    // Vue.component('Scrollbar', Scrollbar);
    /** table */
    Vue.component('my-table',myTable);


    Vue.mixin({
        methods: {
            /**
             * 定位错误信息
             * el 查找error内容的区域的组件
             */
            focusErr(el) {
                if (el) {
                    let errorScroll = el.querySelectorAll('.el-form-item__error')[0];
                    if (errorScroll) {
                        let errEl = errorScroll.parentElement.querySelectorAll('input')[0];
                        if (errEl) {
                            errEl.focus();
                        }
                    }
                }
            },
            /**
             * 设置禁用单元格对应的样式
             */
            tableCellStyle({ row, column, rowIndex, columnIndex }) {
                if (!row.isEnable && column.columnKey != 'operations') {
                    return 'opacity:0.5';
                } else {
                    return '';
                }
            }
        }
    });
    //权限指令。
    Vue.directive('allow', {
        bind: function (el, binding, vnode) {
            //在页面上绑定的 对应权限显示
            let permissionList = binding.value;
            //权限为空时
            if(permissionList.length===0){
                return false
            }
            var roles = ['6','2'];//获取的用户权限
            el.style.display="none";
            for (var i = 0; i < roles.length; i++) {
                if (permissionList.includes(roles[i])) {
                    el.style.display="block";
                    break;
                }
            }
        }
    });
}
